module.exports = __webpack_public_path__ + "img/c3.f816e1a.png";